import { render } from "./SimpleSelector.vue?vue&type=template&id=662d91b7&scoped=true"
import script from "./SimpleSelector.vue?vue&type=script&lang=js"
export * from "./SimpleSelector.vue?vue&type=script&lang=js"

import "./SimpleSelector.vue?vue&type=style&index=0&id=662d91b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662d91b7"]])

export default __exports__